'use client';

import { ArrowRight, ShieldCheck, History, Share2, Award, Sparkles } from 'lucide-react';
import { cn } from '@/utils/cn';

const benefits = [
  {
    number: '01',
    title: 'Escolha livre e consciente',
    description: 'Compare especialidades, currículos e valores transparentes para escolher quem combina com você.',
    icon: ShieldCheck,
    color: 'text-primary bg-primary/10 dark:bg-primary/15 border border-primary/20',
  },
  {
    number: '02',
    title: 'Continuidade do cuidado',
    description: 'Prontuário eletrônico unificado com histórico de consultas, receitas e atestados em um só lugar.',
    icon: History,
    color: 'text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-500/15 border border-emerald-200/60 dark:border-emerald-500/30',
  },
  {
    number: '03',
    title: 'Rede integrada de saúde',
    description: 'Telemedicina ao vivo, consultas domiciliares e médicos plantonistas disponíveis 7 dias por semana.',
    icon: Share2,
    color: 'text-purple-600 dark:text-purple-400 bg-purple-50 dark:bg-purple-500/15 border border-purple-200/60 dark:border-purple-500/30',
  },
  {
    number: '04',
    title: 'Programa de recompensas',
    description: 'Indique amigos, familiares ou pacientes e receba bonificações via PIX a cada atendimento realizado.',
    icon: Award,
    color: 'text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-500/15 border border-amber-200/60 dark:border-amber-500/30',
  },
];

export function Benefits() {
  return (
    <section id="beneficios" className="py-16 lg:py-24 bg-muted/25 border-b border-border transition-colors">
      <div className="container-landing">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary uppercase tracking-widest mb-2">
              <Sparkles className="w-3.5 h-3.5" />
              <span>Mais que uma consulta</span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground tracking-tight">
              Uma jornada completa de cuidado
            </h2>
          </div>

          <a
            href="#como-funciona"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:text-primary-hover hover:underline transition-colors group"
          >
            <span>Conheça como funciona</span>
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit) => {
            const Icon = benefit.icon;
            return (
              <article
                key={benefit.number}
                className="bg-card text-card-foreground p-6 rounded-3xl border border-border/80 dark:border-white/[0.08] shadow-xs hover:shadow-lg dark:hover:shadow-[0_10px_30px_rgba(0,0,0,0.5)] hover:border-primary/30 dark:hover:border-primary/40 transition-all duration-200 flex flex-col justify-between"
              >
                <div>
                  <div className="flex items-center justify-between mb-4">
                    <div className={cn('w-12 h-12 rounded-2xl flex items-center justify-center shrink-0', benefit.color)}>
                      <Icon className="w-6 h-6" />
                    </div>
                    <span className="text-xl font-extrabold text-muted-foreground/30 font-mono">
                      {benefit.number}
                    </span>
                  </div>

                  <h3 className="text-base font-bold text-foreground mb-2">
                    {benefit.title}
                  </h3>

                  <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
